import { render, staticRenderFns } from "./VerticalBlind90mm.vue?vue&type=template&id=4c2c5caa&scoped=true&"
import script from "./VerticalBlind90mm.vue?vue&type=script&lang=js&"
export * from "./VerticalBlind90mm.vue?vue&type=script&lang=js&"
import style0 from "./VerticalBlind90mm.vue?vue&type=style&index=0&id=4c2c5caa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2c5caa",
  null
  
)

export default component.exports